<template>
  <div>
    <div class="panel-heading border-bottom">
      <div class="row">
        <div class="col-lg-12">
        <span>
          <strong>
            <router-link :to="bookmark.path">
              {{ shorten(bookmark.name, 22) }}
            </router-link>
          </strong>
        </span>
        <span class="pull-right">
          <span v-if="showEdit">
            <a @click="showEdit = !showEdit">
              <i class="fa fa-times" v-tooltip="'Close edit view'"></i>
            </a>
            <a @click="saveChanges(bookmark)">
              <i class="fa fa-save" v-tooltip="'Save edit'"></i>
            </a>
          </span>
          <a class="display-inline" @click="showEdit = !showEdit">
            <i class="fa fa-edit" v-tooltip="'Edit bookmark'"></i>
          </a>
          <a @click="deleteBookmark(bookmark.id, bookmark.name)">
            <i class="fa fa-trash red" v-tooltip="'Delete bookmark'"></i>
          </a>
        </span>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
        <div v-if="showEdit">
          <input
            type="text"
            class="form-control m-b-xs m-t-xs"
            placeholder="Enter new name"
            v-model="newName"
          >
          <v-select multiple taggable push-tags :value="bookmark.tags" v-model="newTags" ref="tagItems" close-on-save='true'></v-select>
          <div class="btn btn-xs btn-primary m-t-xs pull-right" @click="saveChanges(bookmark)">Save changes</div>
        </div>
        <div :id="'tags-' + bookmark.id" class="display-block" v-else>
          <span v-for="(tag, index) in bookmark.tags" :key="index" class="label label-primary m-r-xs" style="display: inline-block;">
            {{ tag }}
          </span>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>

import { String } from '../../../mixins/helperMixin'
export default {
  data () {
    return {
      showEdit: false,
      newTags: [],
      newName: null
    }
  },
  props: ['bookmark'],
  mixins: [String],
  mounted () {
    this.newTags = this.bookmark.tags
    this.newName = this.bookmark.name
  },
  methods: {
    async saveChanges (bookmark) {
      await this.$store.dispatch('editBookmark', {...bookmark, ...{tags: this.newTags, name: this.newName}})
      this.showEdit = false
      await this.$store.dispatch('fetchBookmarks')
      this.$toastr.success('Updated bookmark successfully!')
    },
    isNewNameValid () {
      return !(!this.bookmark.name.length || this.bookmarks.map(b => b.name).includes(this.bookmark.name))
    },
    async deleteBookmark (id, name) {
      if (confirm(`Are you sure you want to delete ${name}?`)) {
        try {
          await this.$store.dispatch('deleteBookmark', id)
          this.$toastr.success(`bookmark ${name} deleted`)
          await this.$store.dispatch('fetchBookmarks')
        } catch (error) {
          this.$toastr.error('Unable to delete bookmark')
        }
      }
    }
  }
}
</script>
<style scoped>
.padding-v-1rem {
  padding: 0 1rem 0 1rem;
}
.display-none {
  display: none;
}
.display-block {
  display: block;
}
.display-inline {
  display: inline;
}
ol[dnd-list], ol[dnd-list] > li {
  position: relative;
}
.dd-list .dd-list{
  padding-left: 20px;
}
.key-title {
  text-transform: capitalize;
}
.viewData {
  position: fixed;
  top: 20px;
  right: 280px;
  width: 1024px;
  border: medium none;
  border-radius: 3px;
  -webkit-box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);
  box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);
  z-index: 1100;
  background: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active below version 2.1.8 */

{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Bookmarks/Bookmark.vue